interface StatsCardProps {
  icon: string;
  iconColor: 'blue' | 'green' | 'orange' | 'red';
  value: string;
  label: string;
}

function StatsCard({ icon, iconColor, value, label }: StatsCardProps) {
  const colorStyles = {
    blue: { background: 'rgba(52, 152, 219, 0.1)', color: 'var(--secondary)' },
    green: { background: 'rgba(46, 204, 113, 0.1)', color: 'var(--success)' },
    orange: { background: 'rgba(241, 196, 15, 0.1)', color: 'var(--warning)' },
    red: { background: 'rgba(231, 76, 60, 0.1)', color: 'var(--accent)' },
  };

  return (
    <div className="stat-card">
      <div className="stat-icon" style={colorStyles[iconColor]}>
        <i className={`fas fa-${icon}`}></i>
      </div>
      <div className="stat-info">
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
}

export default StatsCard;

